import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';

const SIZE_OPTIONS = [10, 25, 50, 100];
const SIZE_KEY = 'hydra_page_size';

export function getStoredPageSize() {
    return parseInt(localStorage.getItem(SIZE_KEY)) || 10;
}

/**
 * props:
 * - count   — total de registros
 * - max     — máximo de páginas exibidas (default 10)
 * - size    — tamanho atual da página (lido do pai via URL)
 */
function Pagination(props) {
    const PAGE_SIZE = props.size || getStoredPageSize();
    const MAX_PAGES = props.max || 10;

    const location = useLocation();
    const history = useHistory();

    function useQuery() {
        return new URLSearchParams(location.search);
    }

    const query = useQuery();

    function getPageClass(page) {
        const queryPage = query.get('page');
        // eslint-disable-next-line eqeqeq
        const isActive = queryPage == page || (!queryPage && page === 1);
        return isActive ? 'page-item active' : 'page-item';
    }

    function getPageLink(page) {
        return `${window.location.pathname}?page=${page}&size=${PAGE_SIZE}`;
    }

    function onSizeChange(e) {
        const newSize = parseInt(e.target.value);
        localStorage.setItem(SIZE_KEY, newSize);
        history.push(`${window.location.pathname}?page=1&size=${newSize}`);
    }

    let pagesQty = Math.ceil(props.count / PAGE_SIZE);
    pagesQty = pagesQty > MAX_PAGES ? MAX_PAGES : pagesQty;
    const pages = [];
    for (let i = 1; i <= pagesQty; i++)
        pages.push(i);

    function getBottom() {
        if (props.count === 0)
            return (
                <div className='fw-normal small mt-4 mt-lg-0'>
                    <b>Nenhum resultado encontrado.</b> Crie um primeiro.
                </div>
            );

        const currentPage = parseInt(query.get('page')) || 1;
        const from = (currentPage - 1) * PAGE_SIZE + 1;
        const to = Math.min(currentPage * PAGE_SIZE, props.count);
        const suffix = props.count > PAGE_SIZE * MAX_PAGES
            ? ` (primeiras ${MAX_PAGES} páginas)`
            : '';

        return (
            <div className='fw-normal small mt-4 mt-lg-0'>
                Exibindo <b>{from}–{to}</b> de <b>{props.count}</b>{suffix}
            </div>
        );
    }

    return (
        <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between gap-2">
            <nav aria-label="Page navigation">
                <ul className='pagination mb-0'>
                    {pages.map(p => (
                        <li key={p} className={getPageClass(p)}>
                            <Link className='page-link' to={getPageLink(p)}>{p}</Link>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className='d-flex align-items-center gap-3'>
                {getBottom()}
                <div className='d-flex align-items-center gap-1' style={{ fontSize: 13 }}>
                    <span className='text-muted'>Por página:</span>
                    <select
                        className='form-select form-select-sm'
                        style={{ minWidth: 75 }}
                        value={PAGE_SIZE}
                        onChange={onSizeChange}>
                        {SIZE_OPTIONS.map(s => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default Pagination;
